// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contacts {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  width: 100vw;
  max-width: 430px;
  margin: 0 auto;
  height: 100vh;
  background-color: #fff;
  overflow-y: auto;
  overflow-x: hidden; /*stop horizontal scroll */
  border-radius: 40px;
}


.search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  background-color: #f8f8f7;
  border-bottom: 1px solid #ddd;
  
}

.search-input {
  flex-grow: 1;
  margin-right: 10px;
  border-radius: .65em;
  margin-left: 10px;
  height: 1.5em;
  border-color: lightgray;
}

.contacts-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #f8f8f7;
}

.button-add {
  color: #578de9; /* Green background */
  border: none;
  padding: 4px 8px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 1.75em;
  font-weight: 800;
  cursor: pointer;
  border-radius: 100%;
}

.button-addphone {
  background-color: #5fe86d; /* Green background */
  border: none;
  color: white;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 3px;
  padding-bottom: 3px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-weight: 800;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 100%;
}

.button-add p {
  margin: 0; /* Remove default paragraph margin */
  font-size: 24px; /* Larger font size for the plus sign */
}


.contacts-header h1 {
  font-size: 32px;
  margin: 0;
  padding: 0;
  margin-left: 35px;
  flex-grow: 1;
  text-align: center;
}

.contacts-header input {
  margin: 0 10px;
  padding: 10px;
  flex-grow: 2;
  border: none;
  border-radius: 10px;
  width: calc(100% - 40px); /* Adjust width taking padding and button into account */
}

.contact-list {
  margin: 0;
  padding: 0;
}

.contact-item {
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #ddd;
}

.contact-initials {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: #d1d1d1;
  color: #fff;
  font-size: 18px;
  margin-right: 10px;
}

.contact-name {
  font-size: 18px;
  color: #000;
}
`, "",{"version":3,"sources":["webpack://./src/components/css/Contacts.css"],"names":[],"mappings":"AAAA;EACE,2DAA2D;EAC3D,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB,EAAE,0BAA0B;EAC9C,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;;AAE/B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc,EAAE,qBAAqB;EACrC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;EAChD,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS,EAAE,oCAAoC;EAC/C,eAAe,EAAE,uCAAuC;AAC1D;;;AAGA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,wBAAwB,EAAE,wDAAwD;AACpF;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb","sourcesContent":[".contacts {\n  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  width: 100vw;\n  max-width: 430px;\n  margin: 0 auto;\n  height: 100vh;\n  background-color: #fff;\n  overflow-y: auto;\n  overflow-x: hidden; /*stop horizontal scroll */\n  border-radius: 40px;\n}\n\n\n.search-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  background-color: #f8f8f7;\n  border-bottom: 1px solid #ddd;\n  \n}\n\n.search-input {\n  flex-grow: 1;\n  margin-right: 10px;\n  border-radius: .65em;\n  margin-left: 10px;\n  height: 1.5em;\n  border-color: lightgray;\n}\n\n.contacts-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px;\n  background-color: #f8f8f7;\n}\n\n.button-add {\n  color: #578de9; /* Green background */\n  border: none;\n  padding: 4px 8px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 1.75em;\n  font-weight: 800;\n  cursor: pointer;\n  border-radius: 100%;\n}\n\n.button-addphone {\n  background-color: #5fe86d; /* Green background */\n  border: none;\n  color: white;\n  padding-left: 8px;\n  padding-right: 8px;\n  padding-top: 3px;\n  padding-bottom: 3px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-weight: 800;\n  margin: 4px 2px;\n  cursor: pointer;\n  border-radius: 100%;\n}\n\n.button-add p {\n  margin: 0; /* Remove default paragraph margin */\n  font-size: 24px; /* Larger font size for the plus sign */\n}\n\n\n.contacts-header h1 {\n  font-size: 32px;\n  margin: 0;\n  padding: 0;\n  margin-left: 35px;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.contacts-header input {\n  margin: 0 10px;\n  padding: 10px;\n  flex-grow: 2;\n  border: none;\n  border-radius: 10px;\n  width: calc(100% - 40px); /* Adjust width taking padding and button into account */\n}\n\n.contact-list {\n  margin: 0;\n  padding: 0;\n}\n\n.contact-item {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  border-bottom: 1px solid #ddd;\n}\n\n.contact-initials {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  background-color: #d1d1d1;\n  color: #fff;\n  font-size: 18px;\n  margin-right: 10px;\n}\n\n.contact-name {\n  font-size: 18px;\n  color: #000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
